import { render, staticRenderFns } from "./Export20.vue?vue&type=template&id=767c73a8&scoped=true"
import script from "./Export20.vue?vue&type=script&lang=js"
export * from "./Export20.vue?vue&type=script&lang=js"
import style0 from "./Export20.vue?vue&type=style&index=0&id=767c73a8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767c73a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2859290550/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('767c73a8')) {
      api.createRecord('767c73a8', component.options)
    } else {
      api.reload('767c73a8', component.options)
    }
    module.hot.accept("./Export20.vue?vue&type=template&id=767c73a8&scoped=true", function () {
      api.rerender('767c73a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Export20.vue"
export default component.exports